<template>
  <base-dialog v-model="show" @close="close" :loading="loading" fullscreen>
    <template v-slot:title> {{ title }} </template>
    <div class="d-flex flex-column full-height">
      <div class="d-flex py-2 flex-grow-0">
        <v-text-field
          hide-details
          label="Nhập để tìm kiếm"
          outlined
          prepend-inner-icon="mdi-magnify"
          v-model="params.search"
          dense
        ></v-text-field>
      </div>
      <div class="flex-grow-1 overflow-auto">
        <base-serve-table
          v-if="show"
          ref="table"
          :api="api"
          :headers="headers"
          v-model="selectsStyle"
          :params="params"
          :defaultParams="default_params"
          use-selected
        >
          <template v-slot:[`item.created_at`]="{ item }">
            <span>
              {{ item.created_at | dateTime('short') }}
            </span>
          </template>
          <template v-slot:[`item.updated_at`]="{ item }">
            <span>
              {{ item.updated_at | dateTime('short') }}
            </span>
          </template>
        </base-serve-table>
      </div>
    </div>

    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :disabled="!selectsStyle"
        :loading="loading"
        outlined
        @click="onSubmit"
      >
        Áp dụng
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { API_STYLE } from '@service/api'
export default {
  props: { title: { type: String, default: 'Chọn trình bày bản đồ' } },
  data: () => ({
    show: false,
    loading: false,
    default_params: {
      with: 'workspace,layer',
      sort: 'name',
    },
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        trans: 'sidebar.workspace.name',
        align: 'start',
        sortable: false,
        value: 'workspace.name',
      },
      {
        trans: 'sidebar.layer.name',
        align: 'start',
        sortable: false,
        value: 'layer.name',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
    ],
    params: { search: '' },
    selectsStyle: null,
  }),
  computed: {
    api() {
      return API_STYLE
    },
  },
  methods: {
    open() {
      this.params = { search: '' }
      this.selectsStyle = null
      this.show = true
    },
    close() {
      this.show = false
      this.loading = false
      this.selectsStyle = null
    },
    onSubmit() {
      this.$emit('submit', this.selectsStyle)
      this.close()
    },
  },
}
</script>

<style scoped></style>
